export const prop = 'sourceEngagement';

export const config = (labels) => ({
	id: 'sourceEngagementColumn',
	label: labels.sourceEngagement,
	propName: prop,
	width: 'minmax(20rem, 3fr)',
	sticky: 'left',
	stickyPosition: '0',
	sortBy: prop
});
